// @flow

import {CarouselItem} from './carousel-item';
import {CAROUSEL_MOVE_DIRECTION, CAROUSEL_POSITION} from './carousel.component';

import type {ChildrenArray, Element} from 'react';

export type CarouselChildren = Element<typeof CarouselItem> | ChildrenArray<Element<typeof CarouselItem>>;

export type State = {|
    speed: number,
    listPosition: number,
    currentSlideIndex: number,
    arrowsDisabledPrev: boolean,
    arrowsDisabledNext: boolean,
    draggable: boolean,
    children: CarouselChildren,
|};

export type ChangeDataType = {
    arrows: {
        prev: boolean,
        next: boolean,
    },
};

export type ChangeParamsType = {
    direction: MoveDirectionType,
    position: CarouselPosition,
};

export type MoveDirectionType = $Keys<typeof CAROUSEL_MOVE_DIRECTION>;

export type AfterChange = (data: ChangeDataType) => void;
export type OnDragStop = (data: ChangeParamsType) => void;

export type SlideParameters = {
    id: string,
    startPos: number,
    finishPos: number,
    width: number,
    height: number,
    node: ?HTMLDivElement,
};

export type ViewportParams = {
    width: number,
    startPos: number,
    endPos: number,
};

export type CarouselPosition = $Keys<typeof CAROUSEL_POSITION>;

            // @pb/generate-flow-typed Webpack Loader:
            // Duplicates all internal dependencies imports
            // to be sure all deps are parsed by this loader
            // cause Babel loader removes `import type ...`
            // and e.g. 'typedef.js' files are not included in dist
            
require("./carousel-item");

require("./carousel.component");
